import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeRegisterHelpCardComponent } from './help-card/help-card.component';
import { MeRegisterComponent } from './me-register.component';

const routes: Routes = [
    { path: '', component: MeRegisterComponent },
    { path: 'help-card', component: MeRegisterHelpCardComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MeRegisterRoutesModule {

}
